module.exports = __webpack_public_path__ + "img/上架.a6ec4aa8.svg";